export default "__VITE_ASSET__B4NGUt5v__"